import { render, staticRenderFns } from "./loteamostras.vue?vue&type=template&id=978c9a88&"
import script from "./loteamostras.vue?vue&type=script&lang=js&"
export * from "./loteamostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports